import type { StringNumber } from "web/types/Utils";

const parseReviewSummary = (summary: StringNumber) => {
  return +summary ? (5 * +summary) / 100 : 0;
};

export default parseReviewSummary;
